import request from "../../utils/request";
const url = process.env.VUE_APP_BASE_API;

const CoursesPurchaseResource = {
  GetPaymentAmount(data) {
    return request({
      url: `${url}/course-purchase/payment-amount`,
      method: "POST",
      data
    });
  },
  Purchase(data) {
    return request({
      url: `${url}/course-purchase/purchase`,
      method: "POST",
      data
    });
  },
  CheckTransaction(data) {
    return request({
      url: `${url}/course-purchase/check-transaction`,
      method: "POST",
      data
    });
  },
  ListTracsaction(params) {
    return request({
      url: `${url}/course-purchase/list`,
      method: "GET",
      params
    });
  },
  Detail(params) {
    return request({
      url: `${url}/course-purchase/detail`,
      method: "GET",
      params
    });
  },
  Palpay(data) {
    return request({
      url: "https://payment.api4hub.com/api/create/hocvivu",
      method: "POST",
      data,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
          "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJwcm92aWRlciI6ImhvY3ZpdnUiLCJpYXQiOjE3MTgxMTI4NTksImV4cCI6MTAzNTgwMjY0NTl9.Rq9TWXq31wlRKAGbNarop4tMCuucc9I5w9kyFVv1FgoAblgp7CJT-NwdWyWnnxV7ZnAz6s7z9RYqRltqTod79Q"
      }
    });
  }
};
export { CoursesPurchaseResource as default };
